import axios from 'axios'
import store from '..'
import router from '../../router'
import API from '@/common/api'
import regExp from '../../common/regExp'

export default {
  namespaced: true,
  state: {
    agree: {
      refund: false
    },
    order: null,
    paymentInfo: null,
    userInfo: null,
    tax: null,
    tip: null
  },
  mutations: {
    setAgree (state, data) {
      state.agree[data.terms] = data.isAgree
    },
    setPaymentInfo (state, data) {
      state.paymentInfo = data
    },
    setUserInfo (state, data) {
      state.userInfo = data
    },
    setOrder (state, data) {
      const dataStr = JSON.stringify(data.data)
      const orderId = data.id
      const getOthers = function () {
        let ids = []
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i)
          if (key.includes('order_') && !key.includes(orderId)) {
            ids.push(key)
          }
        }
        return ids
      }
      const otherOrderIds = getOthers()
      otherOrderIds.forEach(function (orderId) {
        localStorage.removeItem(orderId)
      })
      localStorage.setItem(`order_${orderId}`, dataStr)
      router.replace({ params: { orderId: orderId } })
      state.order = data.data
    },
    setTaxTip (state, data) {
      const key = data.key
      const value = data.value
      state[key] = value
    }
  },
  actions: {
    async getOrderId ({ state, commit }, data) {
      try {
        const siteInfo = store.state.authentication
        const staff = siteInfo.staff
        const site = siteInfo.site
        const space = store.state.authentication.space
        const ota = store.state.authentication.public ? await store.dispatch('authentication/getOtaKey') : store.state.authentication.k
        const submitSystemInfo = store.state.submit.submitSystemInfo
        const userInfo = {
          ...state.userInfo,
          ota: ota,
          metakey: siteInfo.metakey,
          ...submitSystemInfo && {
            systemInfo: submitSystemInfo
          }
        }
        const payload = data.isArray
          ? data.payload.map(x => {
            return {
              ...x,
              userInfo: userInfo,
              ...staff && {
                staff: `${staff}.${site}`
              }
            }
          })
          : Object.assign(data, {
            userInfo: userInfo,
            ...staff && {
              staff: `${staff}.${site}`
            }
          })
        const res = await axios.post(`${API.BASE_URL}/service/commerce`, {
          cmd: 'sc-viewer-order',
          func: 'get-order-id',
          siteid: siteInfo.site,
          spaceid: space,
          ...siteInfo.metakey && {
            metakey: siteInfo.metakey
          },
          ota: ota,
          userInfo: userInfo,
          test: siteInfo.test && siteInfo.test === '1',
          ...data.returnURL && { returnURL: data.returnURL },
          payload: {
            cmd: 'sc-service',
            func: 'set-submit',
            catCode: data.submitId || 'system_room_service',
            payload: payload
          },
          ...data.submitId && {
            catCode: data.submitId
          },
          ...data.pgInfo && {
            pgInfo: data.pgInfo
          },
          ...data.language && {
            language: data.language
          }
        })
        // state.paymentInfo = res.data.message
        commit('setPaymentInfo', {
          ...res.data.message,
          ...data.pgInfo
        })
        return res && res.data && res.data.message
          ? { ...res.data, payment: res.data.message.pg || data.pgInfo.pgName, pgid: res.data.message.pgid }
          : res
      } catch (ex) {
        return ex
      }
    },
    async getOrderIdStatus ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/service/commerce`, {
          cmd: 'sc-viewer-order',
          func: 'get-order-id-status',
          orderId: data.orderId
        })
        const cartIds = Array.isArray(res.data.message.payload) ? res.data.message.payload.map(x => x.cartId) : null
        return res.data.message.payload ? cartIds : null
      } catch (ex) {
        return ex.response.data
      }
    },
    async getOrders ({ state }, data) {
      const ota = store.state.authentication.public ? await store.dispatch('authentication/getOtaKey') : store.state.authentication.k
      try {
        const res = await axios.post(`${API.BASE_URL}/service/commerce`, {
          cmd: 'sc-viewer-order-history',
          func: 'get-orders',
          siteid: data.siteid,
          metakey: data.metakey,
          ota: ota
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    async delOrders ({ state }, data) {
      const ota = store.state.authentication.public ? await store.dispatch('authentication/getOtaKey') : store.state.authentication.k
      try {
        const res = await axios.post(`${API.BASE_URL}/service/commerce`, {
          cmd: 'sc-viewer-order-history',
          func: 'del-order',
          orderId: data.orderId,
          siteid: data.siteid,
          metakey: data.metakey,
          ota: ota
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    async getReceipt ({ state }, orderId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/service/commerce`, {
          cmd: 'sc-payment-receipt',
          func: 'get-receipt',
          orderId: orderId
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    async getRefundTerms ({ state }, pgInfo) {
      const siteid = store.state.authentication.site
      try {
        const res = await axios.post(`${API.BASE_URL}/service/commerce`, {
          cmd: 'sc-legal',
          func: 'get-refund-terms',
          siteid: siteid,
          pgInfo: pgInfo
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    async getPgInfo ({ state }, pgid) {
      try {
        const res = await axios.post(`${API.BASE_URL}/service/commerce`, {
          cmd: 'sc-viewer-order',
          func: 'get-pg-info',
          pgid: pgid
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    async sendEmailReceipt ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/service/commerce`, {
          cmd: 'sc-payment-receipt',
          func: 'email-receipt',
          orderId: data.orderId,
          url: data.url,
          email: data.email
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    async supportPgInfo ({ state }, data) {
      const siteInfo = store.state.authentication
      const siteid = siteInfo.site
      try {
        const res = await axios.post(`${API.BASE_URL}/service/commerce`, {
          cmd: 'sc-viewer-order',
          func: 'support-pg-info',
          siteid: siteid,
          /**
           * 가입한 PG사에 상점정보가 여러개인 경우
           * 전송코드에 따라 상점정보가 달라지게 되는데
           * 기본적으로 장바구니에는 여러개의 전송코드가 들어갈 수 있고
           * 상점정보가 여러개인 사이트는 에디터에서 전송코드별 그룹핑하여 요청하는 멀티카트로 설정해야 함
           * 그 경우 요청할 때 전송코드가 하나만 존재하게 되는데
           * 이 때 정보를 이 정송코드 정보를 보내 이에 따라 상점정보를 불러옴
           */
          ...data && data.catCode && {
            catCode: data.catCode
          }
        })
        return res && res.data && res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
  },
  getters: {
    getPaymentInfo: state => state.paymentInfo,
    getOrder: state => state.order,
    getAgree: state => state.agree,
    getTax: state => price => {
      const currency = store.state.common.setting.currency.toUpperCase()
      const taxPer = Number(state.tax / 100)
      const taxPrice = Number(price) * taxPer
      const priceFormat = regExp.priceFormat(taxPrice, currency)
      return regExp.priceUnFormat(priceFormat, currency)
    }
  }
}
